import React, { useEffect } from 'react';
import { Typography } from '@material-ui/core';
import cloneDeep from 'lodash/cloneDeep';
import { uniqueKey } from '../../utils';
import { AnswerActions } from './AnswerActions';
import { renderCarousel } from './renderCarousel';
export function getPageIndex(carouselId, state) {
    var carouselData = state[carouselId];
    if (carouselData) {
        var currentPageId = carouselData.currentPageID;
        var pageIds = Object.keys(carouselData.selectionPath);
        var pageIndex = pageIds.indexOf(currentPageId);
        return pageIndex != -1 ? pageIndex : 0;
    }
    else {
        return 0;
    }
}
var PAGE_CHANGE_TIMEOUT = 300;
var pageChangeTimer;
export var AnswerCarousel = function (_a) {
    var _b;
    var index = _a.index, answers = _a.answers, baseClassName = _a.baseClassName, carousel = _a.carousel, skillApi = _a.skillApi, cardId = _a.cardId, carouselSelectionState = _a.carouselSelectionState, setCarouselSelectionState = _a.setCarouselSelectionState, selectionPath = _a.selectionPath, updateSelectionPath = _a.updateSelectionPath, operatorEscalationKeyword = _a.operatorEscalationKeyword, karakuriWebRootUrl = _a.karakuriWebRootUrl, onClick = _a.onClick, session = _a.session;
    var carouselID = carousel.id;
    var _c = React.useState(carousel.contents[index].id), pageID = _c[0], setPageID = _c[1];
    var defaultCarouselSelectionPath = React.useMemo(function () {
        var defaultCarouselSelectionPath = {
            currentPageID: carousel.contents[0].id,
            selectionPath: carousel.contents.reduce(function (acc, item) {
                acc[item.id] = [];
                return acc;
            }, {}),
        };
        return defaultCarouselSelectionPath;
    }, [carousel]);
    var onChange = function (now, _prev) {
        if (!carousel.contents.length)
            return;
        if (now === undefined)
            return;
        if (!carousel.contents[now].id)
            return;
        var pageId = carousel.contents[now].id;
        if (pageChangeTimer) {
            clearTimeout(pageChangeTimer);
        }
        pageChangeTimer = setTimeout(function () {
            updatePageID(pageId);
        }, PAGE_CHANGE_TIMEOUT);
    };
    var updateCarouselSelectionState = function (state) {
        setCarouselSelectionState(state);
        updateSelectionPath({ carousel: state });
    };
    var ensureCarouselSelectionState = function () {
        var cloneCarouselSelectionState = cloneDeep(carouselSelectionState);
        if (!cloneCarouselSelectionState[carouselID]) {
            cloneCarouselSelectionState[carouselID] = defaultCarouselSelectionPath;
        }
        return cloneCarouselSelectionState;
    };
    var updatePageID = function (pageId) {
        var cloneCarouselSelectionState = ensureCarouselSelectionState();
        cloneCarouselSelectionState[carouselID].currentPageID = pageId;
        setPageID(pageId);
        updateCarouselSelectionState(cloneCarouselSelectionState);
    };
    var updateCarouselSelectionPath = function () {
        var paths = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            paths[_i] = arguments[_i];
        }
        var cloneCarouselSelectionState = ensureCarouselSelectionState();
        cloneCarouselSelectionState[carouselID].selectionPath[pageID] = paths;
        updateCarouselSelectionState(cloneCarouselSelectionState);
    };
    var onActionSelected = function (e, id, external, uri) {
        e.preventDefault();
        if (external) {
            if (uri) {
                return window.open(uri, '_blank', 'noopener,status=yes,scrollbars=yes,resizable=yes');
            }
            onClick("/answer/".concat(id));
        }
        else {
            updateCarouselSelectionPath(id);
        }
    };
    useEffect(function () {
        onChange(index);
        return function () {
            clearTimeout(pageChangeTimer);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (React.createElement(Typography, { paragraph: true, component: "div", className: baseClassName },
        renderCarousel(index, carousel, skillApi, cardId, onChange),
        ((_b = carousel.actions) === null || _b === void 0 ? void 0 : _b.length) && (React.createElement(AnswerActions, { key: uniqueKey('answer-actions', cardId, carouselID, pageID), className: "faq-answer-content__button", cardId: cardId, answers: answers, actions: carousel.actions.filter(function (a) { return a.key === pageID; })[0].value, selectionPath: selectionPath, operatorEscalationKeyword: operatorEscalationKeyword, karakuriWebRootUrl: karakuriWebRootUrl, onActionSelected: onActionSelected, session: session }))));
};
//# sourceMappingURL=AnswerCarousel.js.map